export default __webpack_public_path__ + "static/media/Linda Anderson.3dd7f9ed.mp3";